<div>
  <input
    #search
    type="search"
    class="form-control"
    placeholder="Ex. Drottninggatan eller Stockholm"
    [value]="
      !!modelAndDealerService.dealerSearchInput
        ? modelAndDealerService.dealerSearchInput
        : ''
    "
    maxlength="30"
    (keyup.enter)="onSearch(search.value)"
  />
</div>

<div class="d-flex pt-4">
  <div
    class="pb-2 my-auto d-flex"
    (click)="useClientLocation()"
    *ngIf="geoLocationEnabled"
  >
    <a class="theme-color-primary fs-16" role="button"
      >{{ "maps.myLocation" | translate }}
    </a>
    <span class="ps-1 my-auto text-with-icon">
      <i class="fas fa-map-marker-alt"></i>
    </span>
  </div>
  <div class="ms-auto my-auto d-flex" (click)="toggleMap()">
    <a class="theme-color-primary fs-16" role="button"
      >{{ (!!mapEnabled ? "maps.hideMap" : "maps.showMap") | translate }}
    </a>
    <span class="ps-1 my-auto text-with-icon">
      <i class="fas fa-map-marked-alt"></i>
    </span>
  </div>
</div>

<div class="mw-xl-50 mw-sm-1000 pt-2" *ngIf="mapEnabled">
  <google-map
    [center]="mapLocation"
    height="300px"
    width="100%"
    [zoom]="zoom"
    [options]="options"
    (mapClick)="moveMapLocation($event)"
  >
    <map-marker-clusterer
      *ngIf="!!allLocations"
      [imagePath]="locationClustererImagePath"
      clusterClass="map-cluster"
    >
      <map-marker
        *ngFor="let location of allLocations"
        [position]="location | googleMapsLatLngLit: stockholmCenterCoordinates"
        [options]="
          mapLocation.lng === location.longitude &&
          mapLocation.lat === location.latitude
            ? selectedPlaceIcon
            : placeIcon
        "
        (mapClick)="onMarkerClick($event)"
      ></map-marker>
    </map-marker-clusterer>

    <map-marker
      *ngIf="!!clientLocation"
      [position]="
        clientLocation | googleMapsLatLngLit: stockholmCenterCoordinates
      "
      [options]="clientIcon"
    ></map-marker>
  </google-map>
</div>
